module.exports = __webpack_public_path__ + "img/intersecting_overlaid_hip.fc2232b0.jpg";